if (!customElements.get('sticky-product-bar')) {
  customElements.define(
    'sticky-product-bar',
    class StickyProductBar extends HTMLElement {
      connectedCallback() {
        this.sourceButton = document.getElementById(this.dataset.sourceButton);
        this.sourcePrice = document.getElementById(this.dataset.sourcePrice);
        this.button = this.querySelector('button');
        this.price = this.querySelector('.sdna-sticky-product-bar__price');

        if (!this.sourceButton || !this.button) {
          this.hidden = true;
          return;
        }

        this.handleButtonClick = () => this.onButtonClick();
        this.button.addEventListener('click', this.handleButtonClick);
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.sourceButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        if (this.sourcePrice && this.price) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.sourcePrice, {
            childList: true,
            subtree: true,
          });
        }

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const isVisible = !entry.isIntersecting;
            this.classList.toggle('is-visible', isVisible);
            document.dispatchEvent(new CustomEvent('sticky-product-bar:visibility', { detail: { isVisible } }));
          },
          { threshold: 0.1 },
        );
        this.visibilityObserver.observe(this.sourceButton);
        this.syncButton();
        this.syncPrice();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleButtonClick);
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }

      syncButton() {
        this.button.disabled = this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        this.button.setAttribute('aria-busy', this.sourceButton.classList.contains('loading') ? 'true' : 'false');
        const sourceLabel = this.sourceButton.querySelector('span:not(.loading__spinner)')?.textContent?.trim();

        if (sourceLabel) {
          this.button.querySelector('span').textContent = sourceLabel;
        }
      }

      onButtonClick() {
        if (!this.sourceButton.disabled && this.sourceButton.getAttribute('aria-disabled') !== 'true') {
          this.sourceButton.click();
        }
      }

      syncPrice() {
        if (!this.sourcePrice || !this.price) return;

        const salePrice = this.sourcePrice.querySelector('.price--on-sale .price__sale .price-item--sale');
        const regularPrice = this.sourcePrice.querySelector('.price__regular .price-item--regular');
        const sourcePrice = salePrice?.textContent?.trim() || regularPrice?.textContent?.trim();

        if (sourcePrice) {
          this.price.textContent = sourcePrice;
        }
      }
    },
  );
}
